<template>
  <v-content class="login fill-height background">
    <v-container
      fill-height
      class="flex-column"
    >
      <v-row
        fill-height
        no-gutters
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          lg="6"
          v-if="!accessToken"
        >
          <v-card class="pa-7">
            <p class="font-weight-light primary--text text-center">
              Você precisa solicitar o
              <router-link
                :to="{name:'ForgotPassword'}"
                class="primary--text"
              >
                reset da senha
              </router-link>
            </p>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          v-if="accessToken"
        >
          <v-card class="pa-7">
            <v-form
              ref="resetForm"
              v-model="form"
              @submit.prevent
            >
              <h2 class="headline font-weight-regular primary--text pb-5">
                Cadastrar nova senha
              </h2>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="passwordNew1"
                    :rules="[rules.required, rules.min8]"
                    validate-on-blur
                    label="Nova senha"
                    required
                    class="pb-0"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="passwordNew2"
                    :rules="[rules.required, rules.min8]"
                    label="Confirmação da nova senha"
                    validate-on-blur
                    required
                    class="pb-0"
                    @keyup.enter.native="onSubmit"
                  />
                </v-col>
              </v-row>
              <div class="pt-3 text-right">
                <v-btn
                  text
                  color="accent"
                  :block="$vuetify.breakpoint.smAndDown"
                  :to="{name: 'Login'}"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  :block="$vuetify.breakpoint.smAndDown"
                  @click="onSubmit"
                >
                  Enviar
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
        <v-col
          class="align-center text-center white--text"
          cols="12"
          lg="6"
          order="2"
        >
          <h1 class="headline font-weight-regular pb-5">
            Bem-vindo ao Centro <br>de Memória
          </h1>
          <p
            style="max-width: 400px"
            class="mx-auto"
          >
            A Wilson Sons acredita que os registros da sua trajetória
            são parte integrante do seu legado para a sociedade. Por
            isso, em 2006, implantou o Centro de Memória, que disponibiliza
            o seu acervo on-line para consultas e atende pesquisadores
            do Brasil e do Exterior.
          </p>
          <router-link :to="{name: 'Dashboard'}">
            <img src="@/assets/logo-small.png">
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions } from 'vuex';
import formRules from '@/mixins/form-rules';

/* eslint-disable camelcase */
export default {
  name: 'ResetPassword',
  props: {
    accessToken: {
      type: String,
      default: null,
    },
  },
  mixins: [formRules],
  data() {
    return {
      form: true,
      passwordNew1: '',
      passwordNew2: '',
      error: null,
      showPass: false,
    };
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    onSubmit(evt) {
      evt.preventDefault();
      this.error = null;

      if (this.passwordNew1 !== this.passwordNew2) {
        this.$toasted.error('As senhas precisam ser iguais.');
        return;
      }
      if (this.$refs.resetForm.validate()) {
        this.resetPassword({
          newPassword: this.passwordNew1,
          accessToken: this.accessToken,
        })
          .then(() => {
            this.$toasted.info('Senha alterada com sucesso.');
            this.$router.push({ name: 'Login' });
          })
          .catch((err) => {
            this.$toasted.error(err.message || err);
          });
      }
    },
    onCancel(evt) {
      evt.preventDefault();
      this.$router.go(-1);
    },
    onModalOk() {
      this.$router.go(-1);
    },
  },
};
</script>
